

/**** CREER COMMANDE *****/

export const UTILISATEUR_COMMANDE_INITIATE_CREER_COMMANDE = 'UTILISATEUR_COMMANDE_INITIATE_CREER_COMMANDE';
export const UTILISATEUR_COMMANDE_CREER_COMMANDE_START = 'UTILISATEUR_COMMANDE_CREER_COMMANDE_START';
export const UTILISATEUR_COMMANDE_CREER_COMMANDE_SUCCESS = 'UTILISATEUR_COMMANDE_CREER_COMMANDE_SUCCESS';
export const UTILISATEUR_COMMANDE_CREER_COMMANDE_FAIL = 'UTILISATEUR_COMMANDE_CREER_COMMANDE_FAIL';
export const UTILISATEUR_COMMANDE_CREER_COMMANDE_RESET = 'UTILISATEUR_COMMANDE_CREER_COMMANDE_RESET';


/**** FETCH COMMANDE *****/

export const UTILISATEUR_COMMANDE_INITIATE_FETCH_COMMANDE = 'UTILISATEUR_COMMANDE_INITIATE_FETCH_COMMANDE';
export const UTILISATEUR_COMMANDE_FETCH_COMMANDE_START = 'UTILISATEUR_COMMANDE_FETCH_COMMANDE_START';
export const UTILISATEUR_COMMANDE_FETCH_COMMANDE_SUCCESS = 'UTILISATEUR_COMMANDE_FETCH_COMMANDE_SUCCESS';
export const UTILISATEUR_COMMANDE_FETCH_COMMANDE_FAIL = 'UTILISATEUR_COMMANDE_FETCH_COMMANDE_FAIL';
export const UTILISATEUR_COMMANDE_FETCH_COMMANDE_RESET = 'UTILISATEUR_COMMANDE_FETCH_COMMANDE_RESET';


/**** PAYER COMMANDE *****/

export const UTILISATEUR_COMMANDE_INITIATE_PAYER_COMMANDE = 'UTILISATEUR_COMMANDE_INITIATE_PAYER_COMMANDE';
export const UTILISATEUR_COMMANDE_PAYER_COMMANDE_START = 'UTILISATEUR_COMMANDE_PAYER_COMMANDE_START';
export const UTILISATEUR_COMMANDE_PAYER_COMMANDE_SUCCESS = 'UTILISATEUR_COMMANDE_PAYER_COMMANDE_SUCCESS';
export const UTILISATEUR_COMMANDE_PAYER_COMMANDE_FAIL = 'UTILISATEUR_COMMANDE_PAYER_COMMANDE_FAIL';
export const UTILISATEUR_COMMANDE_PAYER_COMMANDE_RESET = 'UTILISATEUR_COMMANDE_PAYER_COMMANDE_RESET';
